import { render, staticRenderFns } from "./playerLastSeasonRecord.vue?vue&type=template&id=2fcd15c6&scoped=true"
import script from "./playerLastSeasonRecord.vue?vue&type=script&lang=js"
export * from "./playerLastSeasonRecord.vue?vue&type=script&lang=js"
import style0 from "./playerLastSeasonRecord.vue?vue&type=style&index=0&id=2fcd15c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcd15c6",
  null
  
)

export default component.exports